import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Events from "@/pages/Events";
import DewanMakan from "@/pages/DewanMakan";
import StudentOuting from "@/pages/StudentOuting";
import Attendance from "@/pages/Attendance";
import Incidents from "@/pages/Incidents";
import Admin from "@/pages/Admin";
import SeasonalBannerAdmin from "@/pages/SeasonalBannerAdmin";
import OrgChart from "@/pages/OrgChart";
import MyProfile from "@/pages/MyProfile";
import HostelInnovation from "@/pages/HostelInnovation";
import StudentSupportRecord from "@/pages/StudentSupportRecord";
import Layout from "@/components/Layout";
import { canAccessFinancial, canAccessSupportRecords } from "@/lib/permissions";
import Financial from "@/pages/Financial";

const Protected = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;

  const isVisitor = user?.role === "visitor" || user?.staff_role === "Visitor";
  const visitorAllowed = ["/student-outing", "/incidents"];

  if (isVisitor && !visitorAllowed.includes(location.pathname)) {
    return <Navigate to="/student-outing" replace />;
  }
  if (location.pathname === "/student-support-records" && !canAccessSupportRecords(user)) {
    return <Navigate to="/" replace />;
  }
  if (location.pathname === "/financial" && !canAccessFinancial(user)) {
    return <Navigate to="/" replace />;
  }
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/dewan-makan" element={<Protected><DewanMakan /></Protected>} />
            <Route path="/org-chart" element={<Protected><OrgChart /></Protected>} />
            <Route path="/my-profile" element={<Protected><MyProfile /></Protected>} />
            <Route path="/hostel-innovation" element={<Protected><HostelInnovation /></Protected>} />
            <Route path="/student-support-records" element={<Protected><StudentSupportRecord /></Protected>} />
            <Route path="/financial" element={<Protected><Financial /></Protected>} />
            <Route path="/student-outing" element={<Protected><StudentOuting /></Protected>} />
            <Route path="/events" element={<Protected><Events /></Protected>} />
            <Route path="/attendance" element={<Protected><Attendance /></Protected>} />
            <Route path="/incidents" element={<Protected><Incidents /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="/admin/seasonal-banner" element={<Protected adminOnly><SeasonalBannerAdmin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
